import { render, staticRenderFns } from "./W2.vue?vue&type=template&id=97f6a0ae&scoped=true&"
import script from "./W2.vue?vue&type=script&lang=js&"
export * from "./W2.vue?vue&type=script&lang=js&"
import style0 from "./W2.vue?vue&type=style&index=0&id=97f6a0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f6a0ae",
  null
  
)

export default component.exports